import { useEffect, useMemo, useState } from "react";

const STORAGE_KEY = "admin-dark-mode";

export function useDarkMode() {
  const [isDark, setIsDark] = useState<boolean>(() => {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === "true") return true;
    if (stored === "false") return false;
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  });

  useEffect(() => {
    document.documentElement.classList.toggle("dark", isDark);
    window.localStorage.setItem(STORAGE_KEY, String(isDark));
  }, [isDark]);

  const api = useMemo(
    () => ({
      isDark,
      toggle: () => setIsDark((current) => !current),
    }),
    [isDark]
  );

  return api;
}
